import type { ApiClientAxios } from "@repo/api";
import { AllowedChangesBooleanKey } from "@repo/logic";
import {
	BOOLEAN_FLAGS,
	EMPTY_OVERRIDES,
} from "./AllowedChangesDevTool.constants";

export type AllowedChangesFormValues = {
	selectedId: string;
	flags: Partial<Record<AllowedChangesBooleanKey, boolean>>;
};

export type AllowedChangesEffectiveFlagValues = Partial<Record<AllowedChangesBooleanKey, boolean>>;

type AllowedChangesItem = ApiClientAxios.AllowedChangesItem;

export const getEffectiveFlagValue = (
	contract: AllowedChangesItem | undefined,
	key: AllowedChangesBooleanKey,
	effectiveFlagValues: AllowedChangesEffectiveFlagValues = EMPTY_OVERRIDES,
): boolean => {
	const effectiveFlagValue = effectiveFlagValues[key];
	if (effectiveFlagValue !== undefined) {
		return effectiveFlagValue;
	}

	if (!contract) {
		return false;
	}

	if (key === AllowedChangesBooleanKey.CanChangeContactAddress && contract.isContactAddressChangeInProgress === true) {
		return false;
	}

	if (key === AllowedChangesBooleanKey.CanChangeElectronicContacts && contract.isElectronicContactsChangeInProgress === true) {
		return false;
	}

	return Boolean(contract[key as keyof AllowedChangesItem]);
};

export const buildFlagValues = (
	contract?: AllowedChangesItem,
	overrides: Partial<Record<AllowedChangesBooleanKey, boolean>> = EMPTY_OVERRIDES,
	effectiveFlagValues: AllowedChangesEffectiveFlagValues = EMPTY_OVERRIDES,
): Partial<Record<AllowedChangesBooleanKey, boolean>> =>
	BOOLEAN_FLAGS.reduce<Partial<Record<AllowedChangesBooleanKey, boolean>>>((acc, { key }) => {
		const overrideValue = overrides[key];
		acc[key] = overrideValue ?? getEffectiveFlagValue(contract, key, effectiveFlagValues);
		return acc;
	}, {});
